/**
 * Map errors of forms be it front-end validation
 * or validation response objects. Map errors here
 * to enable automatic formatting of form fields
 */
class Errors {
  /**
   * Initiailize empty errors object
   */
  constructor () {
    this.errors = {}
    this.status = null
  }

  /**
   * Determine if an errors exists for the given field.
   *
   * @param {string} field The field to check for errors
   *
   * @returns {boolean}
   */
  has (field) {
    return this.errors.hasOwnProperty(field)
  }

  /**
   * Determine if there are any errors currently
   *
   * @returns {boolean}
   */
  any () {
    return Object.keys(this.errors).length > 0
  }

  /**
   * Return the error message for the given field
   *
   * @param {string} field The field for which to return the assosciated error
   *
   * @returns {string | null}
   */
  get (field) {
    if (this.errors[field]) {
      return this.errors[field][0]
    }
    return null
  }

  /**
   * Return API error responses that return only a single error object
   * and that's not related to a specific field. Else return all errors per field
   * as a line-break list using the <br/> HTML entity
   *
   * @returns {string | null}
   */
  getDefaultErrorMessage () {
    if (this.errors.hasOwnProperty('error')) {
      return this.errors.error
    }

    let errorMessage = []
    const errors = this.errors

    for (let field in errors) {
      errorMessage.push(this.errors[field][0])
    }

    return errorMessage.join('<br/>')
  }

  /**
   * Replace errors object with new errors
   *
   * @param {object} errors The new errors object
   *
   * @returns {void}
   */
  record (errors) {
    this.errors = errors
  }

  /**
   * Clear errors for a specific field or clear all errors
   *
   * @param {string | null} field The field error object to remove
   *
   * @returns {void}
   */
  clear (field) {
    if (field) {
      delete this.errors[field]
      return
    }

    this.errors = {}
    this.status = null
  }

  /**
   * Set the HTTP Error Status Code
   *
   * @param {number} statusCode The HTTP status code returned from the Ajax call
   *
   * @returns {void}
   */
  setStatus (statusCode) {
    this.status = statusCode
  }

  /**
   * Get the current error HTTP status code
   *
   * @return {number | null}
   */
  getStatus () {
    return this.status
  }
}

export { Errors as default }



// WEBPACK FOOTER //
// ./src/api/Errors.js